export default __webpack_public_path__ + "static/unico-live-internacional-4289538045d5a182b49fbc10d3d3cae7.jpg";